export default import.meta.ROLLDOWN_FILE_URL_XKrd65bWbFkOtoRuFyGqUA